import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../static/styles/styles.scss';

const Header = ({ toBeFocusedRef, smoothCursorBlockRef }) => {
    const [isDarkMode, setIsDarkMode] = useState(false);
    const darkLightToggleElementRef = React.useRef(null);

    function handleDarkLightToggleClick() {
        darkLightToggleElementRef.current.classList.toggle('active');
        document.body.classList.toggle('dark');
        if (!isDarkMode) {
            document.body.style.backgroundColor = '#18191A';
            smoothCursorBlockRef.current.style.backgroundColor = '#18191A';
            localStorage.setItem('theme', 'dark');
        } else {
            document.body.style.backgroundColor = '#E4E9F7';
            smoothCursorBlockRef.current.style.backgroundColor = '#E4E9F7';
            localStorage.setItem('theme', 'light');
        }
        setIsDarkMode(!isDarkMode);
        if (toBeFocusedRef && toBeFocusedRef.current) {
            toBeFocusedRef.current.focus();
        }
    }

    useEffect(() => {
        const preferredTheme = localStorage.getItem('theme');
        if (preferredTheme === 'dark') {
            setIsDarkMode(true);
            document.body.classList.add('dark');
            darkLightToggleElementRef.current.classList.add('active');
        } else {
            setIsDarkMode(false);
            document.body.classList.remove('dark');
            darkLightToggleElementRef.current.classList.remove('active');
        }
    }, []);

    return (
        <div className={`header ${isDarkMode ? 'dark' : ''}`}>
            <Link to="/home" className="no-style">
                <h1 id="title">
                    <span>Voice</span> <span>Typing</span>  <span>Test</span> 
                </h1>
            </Link>
            <div
                className={`dark-light ${isDarkMode ? 'active' : ''}`}
                onClick={handleDarkLightToggleClick}
                ref={darkLightToggleElementRef}
            >
          
            </div>
     
        </div>
    );
}

export default Header;